import React from "react";
import { IconButton, Tooltip, Badge, useMediaQuery, useTheme } from "@mui/material";
import { Search } from "lucide-react";
import { styled } from "@mui/material/styles";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(7),
  right: theme.spacing(2),
  backgroundColor: "rgba(139, 92, 246, 0.9)",
  color: "white",
  backdropFilter: "blur(8px)",
  border: "1px solid rgba(139, 92, 246, 0.3)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

  zIndex: 1000,
  pointerEvents: "auto",


  "&:hover": {
    backgroundColor: "rgba(139, 92, 246, 1)",
    transform: "translateY(-2px)",
    boxShadow: "0 8px 24px rgba(139, 92, 246, 0.4)",
  },
  "&:active": {
    transform: "translateY(0)",
  },
  // Mobile adjustments
  [theme.breakpoints.down('sm')]: {
    bottom: theme.spacing(8),
    right: theme.spacing(1),
  },
}));

const NewBadge = styled("span")(({ theme }) => ({
  position: "absolute",
  top: -8,
  right: -8,
  backgroundColor: "#ff4757",
  color: "white",
  fontSize: "10px",
  padding: "2px 6px",
  borderRadius: "10px",
  fontWeight: "bold",
  animation: "pulse 2s infinite",
  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.1)" },
    "100%": { transform: "scale(1)" },
  },
  // Smaller badge on mobile
  [theme.breakpoints.down('sm')]: {
    fontSize: "8px",
    padding: "1px 4px",
    top: -6,
    right: -6,
  },
}));

interface ProductSearchButtonProps {
  onClick: () => void;
}

export const ProductSearchButton = ({ onClick }: ProductSearchButtonProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Tooltip title="Search for products in this frame" placement="left" arrow>
      <StyledIconButton 
        onClick={onClick} 
        size={isMobile ? "small" : "medium"}
      >
        <Badge
          badgeContent={<NewBadge>NEW</NewBadge>}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Search size={isMobile ? 16 : 20} />
        </Badge>
      </StyledIconButton>
    </Tooltip>
  );
};